import type { ApiProyectoBasic } from "@/@types/Api_Extracted";
import { useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { DataTable } from "@/components/ui/datatable";
import { CommonFeatures, EMPTY_ARRAY } from "@/hooks/useTanstackTable";
import { Paginator } from "@/components/ui/paginator";
import { createColumnHelper, tableFeatures, useTable } from "@tanstack/react-table";

export interface ProyectosTableProps {
	readonly rawData: ApiProyectoBasic[] | null;
	readonly isLoading: boolean;
	readonly error: string | null | undefined;
}
export function ProyectosTable(props: ProyectosTableProps) {
	const { columns, features } = useMemo(() => Columns(), []);
	const table = useTable({
		features,
		columns,
		// data: (query.data ?? EMPTY_ARRAY) as Empresa[],
		data: props.rawData ?? EMPTY_ARRAY,
		// state: { columnFilters },
		// onColumnFiltersChange: setColumnFilters,
	});

	return (
		<>
			<DataTable
				table={table}
				noResultsMessage="No tienes ningún proyecto registrado"
				errorMessage={props.error ?? "Error al cargar los proyectos"}
				isLoading={props.isLoading}
				isError={props.error != null}
			/>
			<div className="flex items-center justify-between mt-4">
				<div>
					{table.getPageCount() != 0 && (
						<Paginator
							pageCount={table.getPageCount()}
							pageIndex={table.state.pagination.pageIndex}
							shownPages={5}
							onPageChange={table.setPageIndex}
							canPrevious={table.getCanPreviousPage()}
							canNext={table.getCanNextPage()}
						/>
					)}
				</div>
			</div>
		</>
	);
}

function Columns() {
	const columnHelper = createColumnHelper<typeof features, ApiProyectoBasic>();

	const features = tableFeatures(CommonFeatures);

	const columns = columnHelper.columns([
		columnHelper.accessor("nombre", {
			header: "Nombre",
			size: -1,
			cell: (props) => props.getValue(),
		}),
		// columnHelper.accessor("descripcion", {
		// 	header: "Descripción",
		// 	cell: (props) => props.getValue(),
		// }),
		columnHelper.accessor("referencia", {
			header: "Referencia",
			size: -1,
			cell: (props) => props.getValue(),
		}),
		// columnHelper.accessor((row) => getGramosReferencias(row.lineas), {
		// 	id: "gramosReferencias",
		// 	header: "CO2 Equivalente",
		// 	cell: (props) => convertToBest(props.getValue(), "g"),
		// }),
		columnHelper.display({
			id: "acciones",
			header: "Acciones",
			size: -1,
			cell: (props) => <AccionesFila fila={props.row.original} />,
		}),
	]);

	return { columns, features };
}
function AccionesFila(props: { readonly fila: ApiProyectoBasic; }) {
	const navigate = useNavigate();
	const handleEdit = () => {
		void navigate(props.fila.referencia);
	};

	return (
		<div className="grid grid-cols-1 gap-2">
			<Button variant="secondary" onClick={handleEdit}>
				Editar
			</Button>
		</div>
	);
}